module.exports = __webpack_public_path__ + "img/location.2dd5382b.svg";